export default theme => ({
    '@global': {
        '.au-form-helper-text': {
            whiteSpace: 'normal !important'
        }
    }
})
